/*
 In _breakpoints.scss the same sizes are mentionned
 */

const LAYOUT_MARGIN_INLINE = 20;

export enum DeviceEnum {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
}

export const getDevice = (width: number) => {
  if (width < 834) {
    return DeviceEnum.mobile;
  } else if (width < 1232 + LAYOUT_MARGIN_INLINE * 2) {
    return DeviceEnum.tablet;
  }
  return DeviceEnum.desktop;
};
